<h1 mat-dialog-title>Early Adopter Program</h1>
<div mat-dialog-content>
  <h2 class="mat-h2">What is the Early Adopter Program?</h2>
  <p>
    This program provides Spout users a deep discount for helping us refine and
    improve our recording platform.
  </p>
  <h2 class="mat-h2">
    What are the terms and conditions of the Early Adopter Program?
  </h2>
  <p>
    Spout is providing this deep discount in return for continued feedback so
    that we can improve the quality of the Spout platform. You will be asked to
    provide feedback to Spout every 2 weeks, driven by specific content and user
    experience questions that we will ask. Should you not want to continue to
    provide feedback on a timely basis, your membership fee will change to that
    of the Personal subscription or the program relating to the subscription
    details (storage, features and functionality) that you currently enjoy.
  </p>
  <h2 class="mat-h2">
    How does spout track participation in the Early Adopter Program?
  </h2>
  <p>
    Those members in the Early Adopter program will be required to provide
    content and user experience feedback
    <strong>every 2 weeks</strong> via email or other method of communication.
    Should you not want to continue to provide feedback on a timely basis, your
    membership fee will change to that of the Personal subscription or the
    program relating to the subscription details (storage, features and
    functionality) that you currently enjoy.
  </p>
  <h2 class="mat-h2">
    What happens if I stop participating in the Early Adopter Program?
  </h2>
  <p>
    Should you not want to continue to provide feedback on a timely basis, your
    membership fee will change to that of the Personal subscription or the
    program relating to the subscription details (storage, features and
    functionality) that you currently enjoy.
  </p>
</div>
<div mat-dialog-actions>
  <button
    mat-flat-button
    [mat-dialog-close]="true"
    color="primary"
    cdkFocusInitial>
    Ok
  </button>
</div>
